import React from 'react';
import useLoginModal from './hooks/useLoginModal';
import ModalShell from './components/ModalShell';
import TeacherLoginForm from './components/TeacherLoginForm';
import StudentLoginForm from './components/StudentLoginForm';
import LegacyVerifyForm from './components/LegacyVerifyForm';
import ResetPasswordForm from './components/ResetPasswordForm';

const LoginModal = ({ onClose: externalOnClose }) => {
  const {
    state,
    update,
    handleClose,
    switchTab,
    switchTeacherMode,
    handleSendTeacherCode,
    onLogin,
    handleVerifyCodeChange,
    handleVerifyCodeKeyDown,
    handleVerifyCodePaste,
    handleSendVerifyCode,
    handleResetPassword,
    validatePassword,
    verifyInputRefs,
    loadingStates,
    isOpen,
    goToForgotPassword,
    goToVerifyLogin,
  } = useLoginModal();

  const onClose = externalOnClose || handleClose;

  if (!isOpen && !state.showModal) return null;

  const handleVerifyBack = () => {
    if (state.verifyResult === 'reset_password') {
      update({
        verifyResult: null,
        verifyCode: ['', '', '', '', '', ''],
        showVerifyCode: false,
        newPassword: '',
        confirmPassword: '',
        passwordError: '',
      });
      return;
    }
    if (state.verifyResult) {
      update({ verifyResult: null, verifyCode: ['', '', '', '', '', ''] });
      return;
    }
    if (state.showVerifyCode) {
      update({ showVerifyCode: false });
    } else {
      update({ isVerifyLogin: false, isForgotPassword: false });
    }
  };

  return (
    <ModalShell showModal={state.showModal} onClose={onClose}>
      {state.isVerifyLogin ? (
        <>
          <LegacyVerifyForm
            verifyResult={state.verifyResult}
            showVerifyCode={state.showVerifyCode}
            isForgotPassword={state.isForgotPassword}
            phoneNumber={state.phoneNumber}
            onPhoneNumberChange={(v) => update({ phoneNumber: v })}
            verifyCode={state.verifyCode}
            countdown={state.countdown}
            verifyInputRefs={verifyInputRefs}
            onVerifyCodeChange={handleVerifyCodeChange}
            onVerifyCodeKeyDown={handleVerifyCodeKeyDown}
            onVerifyCodePaste={handleVerifyCodePaste}
            onSendVerifyCode={handleSendVerifyCode}
            onBack={handleVerifyBack}
            loadingStates={loadingStates}
          />
          {state.verifyResult === 'reset_password' && (
            <ResetPasswordForm
              newPassword={state.newPassword}
              onNewPasswordChange={(v) => update({ newPassword: v })}
              confirmPassword={state.confirmPassword}
              onConfirmPasswordChange={(v) => update({ confirmPassword: v })}
              passwordError={state.passwordError}
              onReset={handleResetPassword}
              loadingStates={loadingStates}
              validatePassword={validatePassword}
            />
          )}
        </>
      ) : (
        <>
          {/* 登录Tab */}
          <div className="flex items-center gap-2 mt-5 mb-5 bg-gray-100 rounded-xl p-1 mx-6">
            <button
              onClick={() => switchTab('teacher')}
              className={`flex-1 py-2 rounded-lg text-sm font-medium transition ${
                state.loginTab === 'teacher'
                  ? 'bg-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              账号登录
            </button>
            <button
              onClick={() => switchTab('student')}
              className={`flex-1 py-2 rounded-lg text-sm font-medium transition ${
                state.loginTab === 'student'
                  ? 'bg-white shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              学生登录
            </button>
          </div>

          {state.loginTab === 'teacher' && (
            <TeacherLoginForm
              teacherMode={state.teacherMode}
              onSwitchMode={switchTeacherMode}
              inputAccount={state.inputAccount}
              onAccountChange={(v) => update({ inputAccount: v })}
              inputPassword={state.inputPassword}
              onPasswordChange={(v) => update({ inputPassword: v })}
              teacherCode={state.teacherCode}
              onCodeChange={(v) => update({ teacherCode: v })}
              teacherCodeCountdown={state.teacherCodeCountdown}
              teacherCodeSent={state.teacherCodeSent}
              onSendCode={handleSendTeacherCode}
              loginError={state.loginError}
            />
          )}

          {state.loginTab === 'student' && (
            <StudentLoginForm
              studentId={state.studentId}
              onStudentIdChange={(v) => update({ studentId: v })}
              classId={state.classId}
              onClassIdChange={(v) => update({ classId: v })}
              inputPassword={state.inputPassword}
              onPasswordChange={(v) => update({ inputPassword: v })}
              loginError={state.loginError}
            />
          )}

          <div className="mt-10 space-y-3 px-6 pb-10">
            <button
              onClick={onLogin}
              disabled={
                state.loginTab === 'teacher'
                  ? state.teacherMode == 'password'
                    ? !state.inputAccount || !state.inputPassword
                    : !state.teacherCode
                  : !state.studentId || !state.classId
              }
              className="w-full py-2.5 rounded-xl bg-[hsl(216,89%,55%)] text-white font-medium hover:bg-[hsl(216,89%,45%)] transition"
            >
              {loadingStates.loginZMUid ||
              loadingStates.loginSTU ||
              loadingStates.teacherCodeLogin ? (
                <span className="inline-block w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                '登录'
              )}
            </button>
          </div>

          {state.loginTab === 'teacher' && (
            <div className="flex items-center justify-center gap-5 mb-5 text-sm text-gray-500">
              <span
                className="cursor-pointer hover:text-blue-500 transition"
                onClick={goToVerifyLogin}
              >
                账号注册
              </span>
              <span className="w-px h-4 bg-gray-300" />
              <span
                className="cursor-pointer hover:text-blue-500 transition"
                onClick={goToForgotPassword}
              >
                找回密码
              </span>
            </div>
          )}
        </>
      )}
    </ModalShell>
  );
};

export default LoginModal;
